<template>
    <b-modal :id="modalId" modal-class="modal-checkout-shipping-address modal-my-fullscreen" size="lg"
             centered _hide-footer no-close-on-esc no-close-on-backdrop @hidden="hide">
        <template slot="modal-header">
            <h1 class="modal-title">{{ $t('pages.checkout.shipping_section_title') }}</h1>
            <button type="button" aria-label="Close" class="close" @click="hide"></button>
        </template>

        <div class="shipping-section--content">
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="">{{ $t('shipping_address_fields.first_name') }}</label>
                        <input type="text" name="firstName" v-model="firstName" :data-vv-as="$t('shipping_address_fields.first_name')" v-validate="'required'" class="form-control">
                        <span v-show="errors.has('firstName')" class="field-error">{{ errors.first('firstName') }}</span>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="form-group">
                        <label for="">{{ $t('shipping_address_fields.last_name') }}</label>
                        <input type="text" name="lastName" v-model="lastName" :data-vv-as="$t('shipping_address_fields.last_name')" v-validate="'required'" class="form-control">
                        <span v-show="errors.has('lastName')" class="field-error">{{ errors.first('lastName') }}</span>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="form-group">
                        <label for="">{{ $t('shipping_address_fields.email') }}</label>
                        <input type="email" name="email" v-model="email" :data-vv-as="$t('shipping_address_fields.email')" v-validate="'required|email'" class="form-control">
                        <span v-show="errors.has('email')" class="field-error">{{ errors.first('email') }}</span>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="form-group">
                        <label for="">{{ $t('shipping_address_fields.phone') }}</label>
                        <input type="tel" name="phone" v-model="phone" :data-vv-as="$t('shipping_address_fields.phone')" v-validate="'required'" class="form-control">
                        <span v-show="errors.has('phone')" class="field-error">{{ errors.first('phone') }}</span>
                    </div>
                </div>

                <div class="col-md-8">
                    <div class="form-group">
                        <label for="">{{ $t('shipping_address_fields.street') }}</label>
                        <input type="text" name="street" v-model="street" :data-vv-as="$t('shipping_address_fields.street')" v-validate="'required'" class="form-control">
                        <span v-show="errors.has('street')" class="field-error">{{ errors.first('street') }}</span>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label for="">{{ $t('shipping_address_fields.number') }}</label>
                        <input type="text" name="number" v-model="number" :data-vv-as="$t('shipping_address_fields.number')" v-validate="'required'" class="form-control">
                        <span v-show="errors.has('number')" class="field-error">{{ errors.first('number') }}</span>
                    </div>
                </div>

                <div class="col-md-3">
                    <div class="form-group">
                        <label for="">{{ $t('shipping_address_fields.zip_code') }}</label>
                        <input type="text" name="zipCode" v-model="zipCode" :data-vv-as="$t('shipping_address_fields.zip_code')" v-validate="'required'" class="form-control">
                        <span v-show="errors.has('zipCode')" class="field-error">{{ errors.first('zipCode') }}</span>
                    </div>
                </div>

                <div class="col-md-9">
                    <div class="form-group">
                        <label for="">{{ $t('shipping_address_fields.city') }}</label>
                        <input type="text" name="city" v-model="city" :data-vv-as="$t('shipping_address_fields.city')" v-validate="'required'" class="form-control">
                        <span v-show="errors.has('city')" class="field-error">{{ errors.first('city') }}</span>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="form-group">
                        <label for="">{{ $t('shipping_address_fields.area') }}</label>
                        <input type="text" name="area" v-model="area" :data-vv-as="$t('shipping_address_fields.area')" v-validate="'required'" class="form-control">
                        <span v-show="errors.has('area')" class="field-error">{{ errors.first('area') }}</span>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="form-group">
                        <label for="">{{ $t('shipping_address_fields.country') }}</label>
                        <multiselect
                                :placeholder="$t('shipping_address_fields.country_placeholder')"
                                track-by="alpha_3"
                                :options="countries"
                                v-model="country"
                                :show-labels="false"
                                :custom-label="customLabel"
                        >
                            <template slot="singleLabel" slot-scope="{ option }">
                                <span>{{ option.name }}</span>
                            </template>
                            <template slot="option" slot-scope="{ option }">
                                <span>{{ option.name }}</span>
                            </template>
                            <span slot="noResult">{{ $t('shipping_address_country_not_found') }}</span>
                        </multiselect>
                        <span v-show="countryEmpty" class="field-error">
                            {{ $t('shipping_address_country_validation_error_required') }}
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <template slot="modal-footer">
            <b-button v-if="savingLoader" disabled variant="primary" class="w-100">
                {{ $t('pages.checkout.shipping_section_save_and_calc_message') }}
            </b-button>

            <b-button v-else variant="primary" class="w-100" @click="saveShippingAddress">
                {{ $t('pages.checkout.shipping_section_save_btn') }}
            </b-button>
        </template>
    </b-modal>
</template>


<script>
    import Multiselect from "vue-multiselect"
    import PrintService from '@/services/Print.js'


    export default {
        components: {
            Multiselect
        },

        data() {
            return {
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
                street: '',
                number: '',
                zipCode: '',
                city: '',
                area: '',
                country: '',

                countries: [],
                countryEmpty: false,

                savingLoader: false
            }
        },

        created() {
            this.modalId = 'modal-checkout-shipping-address'
        },

        mounted() {
            PrintService.getCountries().then(response => {
                this.countries = response.data
                // this.selectedCountry = this.countries.find(country => country.alpha_3 === this.country)
            })
        },

        methods: {
            showz() {
                this.$store.commit('SET_NO_SCROLL')

                /*
                Popolo il componente con l'indirizzo eventualmente già salvato
                */
                let shippingAddressFields = this.$store.getters['cart/getShippingAddressFields']

                if (shippingAddressFields.shipping_address_first_name)
                    this.firstName = shippingAddressFields.shipping_address_first_name

                if (shippingAddressFields.shipping_address_last_name)
                    this.lastName = shippingAddressFields.shipping_address_last_name

                if (shippingAddressFields.shipping_address_email)
                    this.email = shippingAddressFields.shipping_address_email
                else
                    this.email = ''  // this.appVars.userEmail

                if (shippingAddressFields.shipping_address_phone)
                    this.phone = shippingAddressFields.shipping_address_phone

                if (shippingAddressFields.shipping_address_street)
                    this.street = shippingAddressFields.shipping_address_street

                if (shippingAddressFields.shipping_address_number)
                    this.number = shippingAddressFields.shipping_address_number

                if (shippingAddressFields.shipping_address_zip_code)
                    this.zipCode = shippingAddressFields.shipping_address_zip_code

                if (shippingAddressFields.shipping_address_city)
                    this.city = shippingAddressFields.shipping_address_city

                if (shippingAddressFields.shipping_address_area)
                    this.area = shippingAddressFields.shipping_address_area

                if (shippingAddressFields.shipping_address_country) {
                    const alpha3 = shippingAddressFields.shipping_address_country
                    this.country = this.countries.find(country => country.alpha_3 === alpha3)
                }

                this.$bvModal.show(this.modalId)
            },

            hide() {
                this.$store.commit('UNSET_NO_SCROLL')

                this.$bvModal.hide(this.modalId)
                // empty form
                this.firstName = ''
                this.lastName = ''
                this.email = ''
                this.phone = ''
                this.street = ''
                this.number = ''
                this.zipCode = ''
                this.city = ''
                this.area = ''
                this.country = ''
                this.countryEmpty = false
            },

            customLabel({ name, alpha3 }) {
                return `${name} ${alpha3}`
            },

            async saveShippingAddress() {
                console.log('saveShippingAddress')
                const validationResult = await this.validateShippingAddress()
                console.log('validationResult', validationResult)
                if (validationResult) {
                    console.log('Form valido!')
                    this.savingLoader = true
                    this.$store.dispatch('cart/saveShippingAddress', {
                        "shipping_address_first_name": this.firstName,
                        "shipping_address_last_name": this.lastName,
                        "shipping_address_email": this.email,
                        "shipping_address_phone": this.phone,
                        "shipping_address_street": this.street,
                        "shipping_address_number": this.number,
                        "shipping_address_zip_code": this.zipCode,
                        "shipping_address_city": this.city,
                        "shipping_address_area": this.area,
                        "shipping_address_country": this.country.alpha_3,
                    }).then(() => {
                        this.savingLoader = false
                        this.hide()
                    })
                }
                else {
                    console.log('Form shipping address non valido!')
                }
            },

            async validateShippingAddress() {
                this.countryEmpty = this.country === ''

                const isOtherFieldsValid = await this.$validator.validateAll()
                console.log('isOtherFieldsValid', isOtherFieldsValid)
                return ! (this.countryEmpty || isOtherFieldsValid === false)
            },
        },
    }
</script>


<!--<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>-->
